import { generateClient } from 'aws-amplify/api';

// AppSync GraphQL client via Amplify v6 generateClient().
// Returns { data: { data: { <resolver>: ... } } } the shape heku-aws.js expects.

const client = generateClient();

const OWNER_QUERY = /* GraphQL */ `
  query OwnerList($keyPrefix: String) {
    owner(keyPrefix: $keyPrefix) {
      id
      key
      value
      _version
    }
  }
`;

const USERS_QUERY = /* GraphQL */ `
  query UsersList($keyPrefix: String) {
    user(keyPrefix: $keyPrefix) {
      id
      key
      value
      _version
    }
  }
`;

const STATISTIC_QUERY = /* GraphQL */ `
  query StatisticList($keyPrefix: String) {
    statistic(keyPrefix: $keyPrefix) {
      id
      key
      value
      _version
    }
  }
`;

const SETTINGS_QUERY = /* GraphQL */ `
  query SettingsList($keyPrefix: String) {
    settings(keyPrefix: $keyPrefix) {
      id
      key
      value
      _version
    }
  }
`;

const OWNER_UPDATE_MUTATION = /* GraphQL */ `
  mutation OwnerUpdate($data: UpdateInput!, $version: Int) {
    ownerUpdate(input: $data, expectedVersion: $version) {
      id
      key
      value
      _version
    }
  }
`;

// Run a GraphQL operation via Amplify and wrap in { data: result }
async function exec(query, variables) {
  const result = await client.graphql({ query, variables });
  return { data: result };
}

export function getSubscription() {
  return exec(OWNER_QUERY, { keyPrefix: 'subscription' });
}

export function getCheckout() {
  return exec(OWNER_QUERY, { keyPrefix: 'checkout' });
}

export function getUserName() {
  return exec(OWNER_QUERY, { keyPrefix: 'user_name' });
}

export function getUsers() {
  return exec(USERS_QUERY, {});
}

export function getStatistic() {
  return exec(STATISTIC_QUERY, {});
}

export function getSettingsList() {
  return exec(SETTINGS_QUERY, {});
}

export function sendSubscription(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'subscription', value },
    version
  });
}

export function sendCheckout(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'checkout', value },
    version
  });
}

export function sendSubscriptionLog(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'log_' + new Date(), value },
    version
  });
}

export function sendFirstConsentDate(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'first_consent_date', value },
    version
  });
}

export function sendUserName(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'user_name', value },
    version
  });
}

export function sendFirstLogin(value, version) {
  return exec(OWNER_UPDATE_MUTATION, {
    data: { key: 'first_login', value },
    version
  });
}
